export default {"src":"/_next/static/media/gl-carousel-1-4.85e7e89a.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};